export default __webpack_public_path__ + "static/media/map.ef530923.png";